module.exports = __webpack_public_path__ + "static/media/iconCanvas12.5d42a16b.svg";